import { render, staticRenderFns } from "./starAnimation.vue?vue&type=template&id=24dfd6af&scoped=true"
import script from "./starAnimation.vue?vue&type=script&lang=js"
export * from "./starAnimation.vue?vue&type=script&lang=js"
import style0 from "./starAnimation.vue?vue&type=style&index=0&id=24dfd6af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfd6af",
  null
  
)

export default component.exports